import React from "react";
import __ from "src/utils/Translations";
import TransHtml from "src/Components/TransHtml";

export const getAreaImportInstructions = (): React.ReactNode[] => [
  <TransHtml text="Pierwszy wiersz pełni funkcję <b>nagłówka</b>, a import danych rozpoczyna się od <b>drugiego wiersza</b>. Zawartość pierwszego <b>wiersza nie jest przetwarzana</b>." />,
  <TransHtml text="Każdy wiersz w pliku powinien zawierać dokładnie <b>7 kolumn</b>. Wypełniasz tylko te pola, które chcesz <b>zaktualizować</b> - pozostałe możesz zostawić <b>puste</b>." />,
  <TransHtml text="Jeśli chcesz wyczyścić dane w danym polu, wpisz <b>„NULL”</b>. To pozwoli <b>usunąć istniejącą wartość</b>." />,
  <TransHtml text="Możesz skorzystać z gotowego <b>szablonu z nazwami kolumn</b> lub wyeksportować plik z <b>aktualnymi obszarami</b>, jeśli chcesz edytować je zbiorczo." />,
  <TransHtml text="Oczekiwany format plików to <b>CSV UTF-8 rozdzielany średnikami lub XLSX</b>" />,
];

export const getAreaUpdateFields = (): string[] => [
  __("Nazwa obszaru"),
  __("Osoba zarządzająca"),
  __("Numer FK osoby zarządzającej"),
  __("Czy osoba zarządzająca będzie członkiem tego obszaru"),
  __("Nadrzędny obszar"),
  __("Wyświetlany dodatkowy obszar"),
  __("Opis obszaru"),
];
